// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../utils/Utils.bs.js");
var React = require("react");
var IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
var MenuV5 = require("../common/Components/menu/MenuV5.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var RescriptCore = require("@rescript/core/src/RescriptCore.bs.js");
var Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var NotificationSettingsUtils = require("./NotificationSettingsUtils.bs.js");
var NotificationSettingsComponents = require("./NotificationSettingsComponents.bs.js");
var NotificationPreferencesAreasInputV5 = require("../../reason/settings/components/NotificationPreferencesAreasInputV5.bs.js");
var NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.bs.js");
var NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.bs.js");
var NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.bs.js");
var NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.bs.js");

function NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypeDisplayGroup(props) {
  var areas = props.areas;
  if (areas.length !== 0) {
    return JsxRuntime.jsx(NotificationSettingsComponents.AreaTypesList.make, {
                areas: areas,
                areaType: props.areaType,
                onRemoveArea: props.onRemoveArea,
                showCount: false,
                style: props.style
              });
  } else {
    return null;
  }
}

var AreaTypeDisplayGroup = {
  make: NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypeDisplayGroup
};

var convertFragment = NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.node, convertFragment, fRef);
}

var ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function NotificationSettingsPreferenceEditDialogAreaGroups$AreaGroupOption(props) {
  var entityType = props.entityType;
  var areaGroup = props.areaGroup;
  var chapter = use(props.chapter);
  var tmp;
  switch (areaGroup.TAG) {
    case "UserAreaGroup" :
        tmp = areaGroup.usedFor;
        break;
    case "ChapterAreaGroup" :
    case "NewAreaGroup" :
        tmp = [entityType];
        break;
    
  }
  var notificationTypes = NotificationSettingsUtils.notificationTypesString(tmp);
  switch (areaGroup.TAG) {
    case "UserAreaGroup" :
        return "My custom " + notificationTypes + " areas";
    case "ChapterAreaGroup" :
        return "My chapter (" + chapter.displayName + ") areas";
    case "NewAreaGroup" :
        return "Create new custom areas for " + notificationTypes;
    
  }
}

var AreaGroupOption = {
  ChapterFragment: ChapterFragment,
  make: NotificationSettingsPreferenceEditDialogAreaGroups$AreaGroupOption
};

function mapCensusPlaceTypeToCityType(x) {
  if (x === "CENSUS_PLACE") {
    return "CITY";
  } else {
    return x;
  }
}

function NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypesDisplayer(props) {
  var style = props.style;
  var onRemoveArea = props.onRemoveArea;
  var areas = props.areas;
  var areaTypes = [
    "STATE",
    "COUNTY",
    "CITY",
    "TOWNSHIP",
    "NEIGHBORHOOD",
    "ZIP_CODE",
    "SCHOOL_DISTRICT",
    "SCHOOL",
    "BLOCK_GROUP",
    "CENSUS_PLACE"
  ];
  return JsxRuntime.jsx("div", {
              children: areaTypes.map(function (areaType) {
                    return JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypeDisplayGroup, {
                                areas: areas.filter(function (a) {
                                      return mapCensusPlaceTypeToCityType(a.type_) === areaType;
                                    }),
                                areaType: areaType,
                                onRemoveArea: onRemoveArea,
                                style: style
                              }, areaType);
                  }),
              className: "flex flex-col gap-4"
            });
}

var AreaTypesDisplayer = {
  make: NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypesDisplayer
};

var convertFragment$1 = NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.node, convertFragment$1, fRef);
}

var ChapterFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var areaTypeV5_decode = NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.Utils.areaTypeV5_decode;

var matchableEntityType_decode = NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.Utils.matchableEntityType_decode;

var convertFragment$2 = NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.node, convertFragment$2, fRef);
}

var SettingsFragment_areaTypeV5_fromString = NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.Utils.areaTypeV5_fromString;

var SettingsFragment_matchableEntityType_fromString = NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.Utils.matchableEntityType_fromString;

var SettingsFragment = {
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: SettingsFragment_areaTypeV5_fromString,
  matchableEntityType_decode: matchableEntityType_decode,
  matchableEntityType_fromString: SettingsFragment_matchableEntityType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

var convertFragment$3 = NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.node, convertFragment$3, fRef);
}

var AreaGroupFragment_areaTypeV5_decode = NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.Utils.areaTypeV5_decode;

var AreaGroupFragment_areaTypeV5_fromString = NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.Utils.areaTypeV5_fromString;

var AreaGroupFragment = {
  areaTypeV5_decode: AreaGroupFragment_areaTypeV5_decode,
  areaTypeV5_fromString: AreaGroupFragment_areaTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function notificationTypeSortWeight(nlist) {
  return Core__Array.reduce(nlist.map(function (x) {
                  switch (x) {
                    case "BUYER_NEED" :
                        return -10;
                    case "FOR_SALE_PROPERTY" :
                        return -1000;
                    case "RENTAL_NEED" :
                        return -1;
                    case "RENTAL_PROPERTY" :
                        return -100;
                    
                  }
                }), 0, (function (prim0, prim1) {
                return prim0 + prim1 | 0;
              }));
}

function NotificationSettingsPreferenceEditDialogAreaGroups(props) {
  var fieldResult = props.fieldResult;
  var preferenceType = props.preferenceType;
  var setAreaGroup = props.setAreaGroup;
  var currentAreaGroup = props.currentAreaGroup;
  var settings = use$2(props.settings);
  var match = React.useState(function () {
        return Object.fromEntries(Core__Option.getOr(settings.userAreaGroups, []).map(function (areaGroup) {
                        return [
                                areaGroup.id,
                                {
                                  TAG: "UserAreaGroup",
                                  id: areaGroup.id,
                                  areas: Core__Array.filterMap(Core__Array.keepSome(Core__Option.getOr(areaGroup.areas, [])), (function (a) {
                                          return Core__Option.map(areaTypeV5_decode(a.type_), (function (t) {
                                                        return {
                                                                id: a.id,
                                                                label: a.label,
                                                                type_: t
                                                              };
                                                      }));
                                        })),
                                  usedFor: Core__Array.filterMap(Core__Option.getOr(areaGroup.usedFor, []), (function (v) {
                                          return matchableEntityType_decode(v);
                                        }))
                                }
                              ];
                      }));
      });
  var existingCustomAreaGroups = match[0];
  var setAreaGroup$1 = function (areaGroup) {
    var areaGroupId = NotificationSettingsUtils.getAreaGroupId(areaGroup);
    existingCustomAreaGroups[areaGroupId] = areaGroup;
    setAreaGroup(areaGroup);
  };
  var chapter = use$1(props.chapter);
  var match$1 = chapter.notificationPreferences;
  var tmp;
  switch (preferenceType) {
    case "BUYER_NEED" :
        if (match$1 !== undefined) {
          var match$2 = match$1.buyerNeeds;
          tmp = match$2 !== undefined ? match$2.areaGroup.fragmentRefs : RescriptCore.panic("Expected a chapter default area group to exist for the given entity type.");
        } else {
          tmp = RescriptCore.panic("Expected a chapter default area group to exist for the given entity type.");
        }
        break;
    case "FOR_SALE_PROPERTY" :
        if (match$1 !== undefined) {
          var match$3 = match$1.forSaleProperties;
          tmp = match$3 !== undefined ? match$3.areaGroup.fragmentRefs : RescriptCore.panic("Expected a chapter default area group to exist for the given entity type.");
        } else {
          tmp = RescriptCore.panic("Expected a chapter default area group to exist for the given entity type.");
        }
        break;
    case "RENTAL_NEED" :
        if (match$1 !== undefined) {
          var match$4 = match$1.rentalNeeds;
          tmp = match$4 !== undefined ? match$4.areaGroup.fragmentRefs : RescriptCore.panic("Expected a chapter default area group to exist for the given entity type.");
        } else {
          tmp = RescriptCore.panic("Expected a chapter default area group to exist for the given entity type.");
        }
        break;
    case "RENTAL_PROPERTY" :
        if (match$1 !== undefined) {
          var match$5 = match$1.rentalProperties;
          tmp = match$5 !== undefined ? match$5.areaGroup.fragmentRefs : RescriptCore.panic("Expected a chapter default area group to exist for the given entity type.");
        } else {
          tmp = RescriptCore.panic("Expected a chapter default area group to exist for the given entity type.");
        }
        break;
    
  }
  var chapterDefaultAreaGroup = use$3(tmp);
  var chapterDefaultAreaGroup_0 = chapterDefaultAreaGroup.id;
  var chapterDefaultAreaGroup_1 = Core__Array.filterMap(Core__Array.keepSome(Core__Option.getOr(chapterDefaultAreaGroup.areas, [])), (function (v) {
          return Core__Option.map(areaTypeV5_decode(v.type_), (function (t) {
                        return {
                                id: v.id,
                                label: v.label,
                                type_: t
                              };
                      }));
        }));
  var chapterDefaultAreaGroup$1 = {
    TAG: "ChapterAreaGroup",
    id: chapterDefaultAreaGroup_0,
    areas: chapterDefaultAreaGroup_1
  };
  var areaGroupOptions = Utils.$$Array.uniq(Belt_Array.concatMany([
            [
              chapterDefaultAreaGroup$1,
              currentAreaGroup
            ],
            Object.values(existingCustomAreaGroups)
          ]), (function (areaGroup) {
          return NotificationSettingsUtils.getAreaGroupId(areaGroup);
        }));
  areaGroupOptions.sort(function (a, b) {
        switch (a.TAG) {
          case "UserAreaGroup" :
              switch (b.TAG) {
                case "UserAreaGroup" :
                    if (notificationTypeSortWeight(a.usedFor) < notificationTypeSortWeight(b.usedFor)) {
                      return -1;
                    } else {
                      return 1;
                    }
                case "ChapterAreaGroup" :
                    return 1;
                case "NewAreaGroup" :
                    return 0;
                
              }
          case "ChapterAreaGroup" :
              switch (b.TAG) {
                case "UserAreaGroup" :
                    return -1;
                case "ChapterAreaGroup" :
                case "NewAreaGroup" :
                    return 0;
                
              }
          case "NewAreaGroup" :
              return 0;
          
        }
      });
  var match$6 = areaGroupOptions.find(function (v) {
        switch (v.TAG) {
          case "UserAreaGroup" :
              var match = v.usedFor;
              if (match.length !== 1) {
                return false;
              }
              var n = match[0];
              return n === preferenceType;
          case "ChapterAreaGroup" :
          case "NewAreaGroup" :
              return false;
          
        }
      });
  if (match$6 === undefined) {
    var tmp$1;
    switch (currentAreaGroup.TAG) {
      case "UserAreaGroup" :
      case "ChapterAreaGroup" :
          tmp$1 = currentAreaGroup.areas;
          break;
      case "NewAreaGroup" :
          tmp$1 = currentAreaGroup.areas;
          break;
      
    }
    areaGroupOptions.push({
          TAG: "NewAreaGroup",
          areas: tmp$1
        });
  }
  var tmp$2;
  switch (currentAreaGroup.TAG) {
    case "UserAreaGroup" :
        var usedFor = currentAreaGroup.usedFor;
        tmp$2 = usedFor.includes(preferenceType) ? "This is the custom area group you set for your " + (Utils.$$String.enumerate(Core__List.fromArray(usedFor.map(function (v) {
                          return NotificationSettingsUtils.toDisplayStringSingular(v);
                        }))) + " filters. Any changes you make will apply everywhere this filter is in place.") : "You've selected your custom area group for " + (Utils.$$String.enumerate(Core__List.fromArray(usedFor.map(function (v) {
                          return NotificationSettingsUtils.toDisplayStringSingular(v);
                        }))) + (" filters. Click Save Changes to also use these areas for " + (NotificationSettingsUtils.toDisplayStringPlural(preferenceType) + ".")));
        break;
    case "ChapterAreaGroup" :
        tmp$2 = "These are the default areas for your chapter. To customize the areas you receive emails about, select a custom area group from the dropdown.";
        break;
    case "NewAreaGroup" :
        tmp$2 = "You are creating a new custom area group for " + (NotificationSettingsUtils.toDisplayStringPlural(preferenceType) + ". Once you have saved your changes you can use this area group with other filters, too.");
        break;
    
  }
  var tmp$3;
  var exit = 0;
  var areas;
  switch (currentAreaGroup.TAG) {
    case "UserAreaGroup" :
        areas = currentAreaGroup.areas;
        exit = 1;
        break;
    case "ChapterAreaGroup" :
        tmp$3 = JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypesDisplayer, {
                    areas: currentAreaGroup.areas,
                    style: "Minimal"
                  }),
              className: "mt-2"
            });
        break;
    case "NewAreaGroup" :
        areas = currentAreaGroup.areas;
        exit = 1;
        break;
    
  }
  if (exit === 1) {
    var tmp$4;
    tmp$4 = fieldResult !== undefined && fieldResult.TAG !== "Ok" ? "error" : undefined;
    tmp$3 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(NotificationPreferencesAreasInputV5.make, {
                  onChange: (function (area) {
                      if (area === undefined) {
                        return ;
                      }
                      var newAreas = areas.slice();
                      newAreas.push({
                            id: area.id,
                            label: area.label,
                            type_: area.type_
                          });
                      var tmp;
                      switch (currentAreaGroup.TAG) {
                        case "UserAreaGroup" :
                            tmp = {
                              TAG: "UserAreaGroup",
                              id: currentAreaGroup.id,
                              areas: newAreas,
                              usedFor: currentAreaGroup.usedFor
                            };
                            break;
                        case "ChapterAreaGroup" :
                            tmp = currentAreaGroup;
                            break;
                        case "NewAreaGroup" :
                            tmp = {
                              TAG: "NewAreaGroup",
                              areas: newAreas
                            };
                            break;
                        
                      }
                      setAreaGroup$1(tmp);
                    }),
                  status: tmp$4,
                  excludeItemFn: (function (area) {
                      return Core__Option.isNone(areas.find(function (a) {
                                      return a.id === area.id;
                                    }));
                    })
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypesDisplayer, {
                        areas: areas,
                        onRemoveArea: (function (areaId) {
                            var newAreas = areas.filter(function (area) {
                                  return area.id !== areaId;
                                });
                            var tmp;
                            switch (currentAreaGroup.TAG) {
                              case "UserAreaGroup" :
                                  tmp = {
                                    TAG: "UserAreaGroup",
                                    id: currentAreaGroup.id,
                                    areas: newAreas,
                                    usedFor: currentAreaGroup.usedFor
                                  };
                                  break;
                              case "ChapterAreaGroup" :
                                  tmp = currentAreaGroup;
                                  break;
                              case "NewAreaGroup" :
                                  tmp = {
                                    TAG: "NewAreaGroup",
                                    areas: newAreas
                                  };
                                  break;
                              
                            }
                            setAreaGroup$1(tmp);
                          })
                      }),
                  className: "mt-4"
                })
          ]
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: "Areas",
                      className: "font-semibold text-lg text-gray-900"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(MenuV5.Menu.make, {
                              button: JsxRuntime.jsxs(ButtonsV5.Button.make, {
                                    className: "!font-normal !normal-case !py-2 flex item-center justify-between gap-4",
                                    children: [
                                      JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups$AreaGroupOption, {
                                            areaGroup: currentAreaGroup,
                                            chapter: chapter.fragmentRefs,
                                            entityType: preferenceType
                                          }),
                                      JsxRuntime.jsx(IconV5.make, {
                                            icon: "arrow-down",
                                            size: 14,
                                            className: "text-gray-500"
                                          })
                                    ]
                                  }),
                              children: areaGroupOptions.map(function (areaGroup) {
                                    return JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                                onAction: (function () {
                                                    setAreaGroup$1(areaGroup);
                                                  }),
                                                children: JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups$AreaGroupOption, {
                                                      areaGroup: areaGroup,
                                                      chapter: chapter.fragmentRefs,
                                                      entityType: preferenceType
                                                    })
                                              }, NotificationSettingsUtils.getAreaGroupId(areaGroup));
                                  })
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: tmp$2,
                                    className: "italic p-2 pl-0 mt-2 text-gray-500"
                                  })
                            }),
                        JsxRuntime.jsx("div", {
                              children: tmp$3
                            }),
                        JsxRuntime.jsx(Form__Components.FieldErrorV2.make, {
                              valid: fieldResult
                            })
                      ],
                      className: "p-2"
                    })
              ],
              className: "p-4"
            });
}

var make = NotificationSettingsPreferenceEditDialogAreaGroups;

exports.AreaTypeDisplayGroup = AreaTypeDisplayGroup;
exports.AreaGroupOption = AreaGroupOption;
exports.mapCensusPlaceTypeToCityType = mapCensusPlaceTypeToCityType;
exports.AreaTypesDisplayer = AreaTypesDisplayer;
exports.ChapterFragment = ChapterFragment$1;
exports.SettingsFragment = SettingsFragment;
exports.AreaGroupFragment = AreaGroupFragment;
exports.notificationTypeSortWeight = notificationTypeSortWeight;
exports.make = make;
/* Utils Not a pure module */
